import { create } from "zustand";
import type { Mood, Scale } from "@andrum/schemas";

interface CheckInDraft {
  mood: Mood | null;
  energy: Scale | null;
  stress: Scale | null;
  note: string;
}

interface CheckInStore {
  draft: CheckInDraft;
  setMood: (mood: Mood) => void;
  setEnergy: (energy: Scale) => void;
  setStress: (stress: Scale) => void;
  setNote: (note: string) => void;
  reset: () => void;
  isComplete: () => boolean;
}

const empty: CheckInDraft = {
  mood: null,
  energy: null,
  stress: null,
  note: "",
};

export const useCheckInStore = create<CheckInStore>((set, get) => ({
  draft: { ...empty },
  setMood: (mood) => set((s) => ({ draft: { ...s.draft, mood } })),
  setEnergy: (energy) => set((s) => ({ draft: { ...s.draft, energy } })),
  setStress: (stress) => set((s) => ({ draft: { ...s.draft, stress } })),
  setNote: (note) => set((s) => ({ draft: { ...s.draft, note } })),
  reset: () => set({ draft: { ...empty } }),
  isComplete: () => get().draft.mood !== null,
}));
